import React, { Fragment, useState, useEffect, useRef } from "react";
import ComponentCard from "../../Cards/ComponentCard/ComponentCard";
import PinInputList from "../PinInput/InputPinV2/InputList/PinInputList";
import PinOutputList from "../PinOut/OutputV2/OutputList/PinOutputList";
import classes from "./AppView.module.css";
import EditViewIcon from "../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/EditView.svg";
import EditSiteIcon from "../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/settings_white.png";
import EditPinsView from "./EditPinsView";
import PinsView from "./PinsView";
import PreviousPageIcon from "../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Table Icons/Pagination Icon/back.png";
import gatewayIcon from "../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/gatewayLogoPortal.png";
import battery100 from "../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/SensorIcons/battery_100.png";

import signal100 from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/signal_100.png'
import signal75 from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/signal_75.png'
import signal50 from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/signal_50.png'
import signal25 from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/signal_25.png'
import signal0 from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/signal_0.png'
import warning from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/yellow_warn.png'
import warningRed from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/red_warn.png'

import linkedIcon from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/link.png'

import { useSocketHook } from "../../../../Socket/useSocketHook";
import parsePinStates from "../../../../Socket/parsePinStates";
import { useDispatch, useSelector } from "react-redux";
import { getSingleDeviceData } from "../../../../Api Methods/Api";
import { serviceActions } from "../../../../store/service-Slice";

const AppView = ({ singleDevicePins, deviceUUID, setPinEdited, firmware, setHasDeviceChanged, socketPinStates, siteData, setSiteData, linkedTo, setUpdateLinkedTo }) => {
    
    const [showEditPinView, setShowEditPinView] = useState(false);
    const [showEditPinForm, setShowEditPinForm] = useState(false);
    const portalName = siteData.data[0].tag !== "" ? siteData.data[0].tag : "No name set"
    const DeviceDetails = useSelector(state => state.service.DeviceDetails);
    const role = useSelector(state => state.auth.role);
    const DeviceDetailsExtras = useSelector(state => state.service.DeviceDetailsExtras);
    const gatewayBattery = siteData.data[0].gatewayBattery?.battery ?? null;    
    console.log(siteData.data[0].gatewayBattery?.battery);
    console.log("battery:" + gatewayBattery);
    

    const gatewaySignal = siteData.data[0].gatewayBattery?.signal ?? null;
    console.log(siteData.data[0]);
    console.log("signal:" + gatewaySignal);
    const gatewayStatus = siteData.data[0].gatewayBattery?.status || null;
    const gatewayLastSeen = siteData.data[0].gatewayBattery?.lastSeenAt ?? null;
    const formatLastSeen = (raw) => {
        if (!raw) return null;
        const d = new Date(raw.replace(' ', 'T'));
        if (isNaN(d)) return raw;
        return d.toLocaleString('en-GB', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
    };
    console.log("gateway status:" + gatewayStatus);
    const HandleShowEditPinForm = () => {
        setShowEditPinForm((prevShowEditPinForm) => !prevShowEditPinForm)
    }

    const isSetRef = useRef(false);
    const token = localStorage.getItem('token');
    const client = localStorage.getItem('client');
    const DeviceUUID = localStorage.getItem('DeviceUUID');
    const dispatch = useDispatch();
    const apiData = {
        token,
        client
    }

    const HandleToggleEditPinView = () => {
        setShowEditPinView((prevShowPinView) => !prevShowPinView);   
        setShowEditPinForm(false);
    }

    const batteryColours = (batteryLevel) => {
        if (batteryLevel > 0 && batteryLevel < 25) {
            return "rgb(220,114,119)";
        } else if (batteryLevel >= 25 && batteryLevel < 50) {
            return "rgb(248,183,131)";
        } else if (batteryLevel >= 50) {
            return "rgb(101,151,100)";
        } else {
            return "rgb(123, 123, 123)";
        }
    }

    let signalIcon = signal0;
    if (gatewaySignal >= 75) {
        signalIcon = signal100;
    } else if (gatewaySignal >= 50) {
        signalIcon = signal75;
    } else if (gatewaySignal >= 25) {
        signalIcon = signal50;
    } else if (gatewaySignal >= 0) {
        signalIcon = signal25;
    }

    const isStale = gatewayStatus === "potentiallyStale";
    const isOffline = gatewayStatus === "stale";

    const gatewayDotColor = {
        online: "rgb(3, 160, 92)",
        offline: "rgb(195, 12, 18)",
        stale: "rgb(150, 150, 150)",
        potentiallyStale: "rgb(150, 150, 150)",
        unknown: "rgb(150, 150, 150)",
    }[gatewayStatus] ?? null;

    const siteType = siteData.data[0].type;
    const isIonDevice = siteType === "AB" || siteType === "A" || siteType === "ESP";

    const navigateToSite = (uuid) => {

    }

    return (
        <>

        <div style={{display:"flex", flexDirection:"column"}}>
        {linkedTo?.length > 0 && (
            <div
                style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "5px",
                    marginBottom: "10px"
                }}>

                <img
                    style={{ width: "20px", height: "20px" }}
                    src={linkedIcon}
                />

                <div>
                    {linkedTo.map((site) => (
                        <h5
                            key={site.uuid}
                            className={classes.description}
                            style={{ marginLeft: 0, marginBottom: 5 }}
                            
                        >
                            {site.type === "controlled" ? "Controlled by " : "Controlling "}
                            <a
                                href={`/Dashboard/SiteView/${site.uuid}`}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {site.siteName ? site.siteName : site.siteId}
                            </a>
                        </h5>
                    ))}
                </div>
            </div>
            )}
        

        <div className={classes["appView-container"]} style={isIonDevice ? { border: "3px solid #5fdc8d" } : undefined}>
          

            <div style={{ display: "flex", backgroundColor:"#efefef" }}>
                <div className={classes["appview-controls2"]}>
                    {showEditPinForm &&
                        <button className={classes.appViewBackArrow}  onClick={() => setShowEditPinForm(false)}>
                            <img className={classes.PreviousPageButtonImg} src={PreviousPageIcon} />
                        </button>
                    }

                    <p style={{color:"#575967", fontSize:"19px", fontWeight:"500", textAlign: "center", maxWidth:"calc(100% - 120px)", whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis"}}>{portalName}</p>

                   <p style={{color:"#999999", marginTop:"40px", fontSize:"16px", fontWeight:"600"}}>{siteData.data[0].key}</p>
                   
                    {(role === "admin" || role === "TechSupport") && (
                        <button className={`${classes.ToggleEditPinView} ${showEditPinView && classes.ToggleEditPinViewActive}`} onClick={HandleToggleEditPinView}>
                            <img className={showEditPinView ? classes.activeImg : classes.img} src={EditSiteIcon} />
                        </button>
                    )}
                </div>
            </div>
            {gatewayBattery !== null && (
                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "5px", paddingTop: "8px", backgroundColor: "#efefef" }}>
                    {gatewayDotColor && (
                        <div style={{ width: 10, height: 10, borderRadius: "50%", backgroundColor: gatewayDotColor, flexShrink: 0 }} />
                    )}
                    <img style={{ width: "25px" }} src={gatewayIcon} />
                    <div style={{ position: "relative", width: 45, height: 45 }}>
                        <p style={{ position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center", margin: 0, fontWeight: 600, color: "#ffffff", fontSize: 12, zIndex: 1 }}>
                            {gatewayBattery !== 0 ? `${gatewayBattery}%` : "?"}
                        </p>
                        <div style={{
                            width: 45,
                            height: 45,
                            backgroundColor: batteryColours(gatewayBattery),
                            WebkitMaskImage: `url(${battery100})`,
                            WebkitMaskSize: "contain",
                            WebkitMaskRepeat: "no-repeat",
                            WebkitMaskPosition: "center",
                            maskImage: `url(${battery100})`,
                            maskSize: "contain",
                            maskRepeat: "no-repeat",
                            maskPosition: "center",
                        }} />
                    </div>
                    {gatewaySignal !== null && (
                        <div style={{ position: "relative", width: 27, height: 27 }}>
                            <img src={signalIcon} style={{ width: 27, height: 27 }} />
                            {isStale && <img src={warning} style={{ width: 27, height: 27, position: "absolute", bottom: 0, right: 0 }} />}
                            {isOffline && <img src={warningRed} style={{ width: 27, height: 27, position: "absolute", bottom: 0, right: 0 }} />}
                        </div>
                    )}
                </div>
            )}
            {gatewayLastSeen && (
                <p style={{ margin: 0, paddingBottom: "6px", textAlign: "center", fontSize: "11px", color: "#9a9a9a", backgroundColor: "#efefef" }}>
                    Last updated {formatLastSeen(gatewayLastSeen)}
                </p>
            )}
            
            {showEditPinView ? <EditPinsView singleDevicePins={singleDevicePins} HandleToggleEditPinView={HandleToggleEditPinView} showEditPinForm={showEditPinForm} setShowEditPinForm={setShowEditPinForm} HandleShowEditPinForm={HandleShowEditPinForm} setPinEdited={setPinEdited} siteData={siteData} setSiteData={setSiteData} DeviceDetails={DeviceDetails} DeviceDetailsExtra={DeviceDetailsExtras}/>
                :
                <PinsView singleDevicePins={singleDevicePins} sokectPinStates={socketPinStates} firmware={firmware} />
            }
        </div>
        </div>
        </>
    );
}


export default AppView;